export const debatePositions = {
    "og": {
        "title": "Opening Government"
    },
    "oo": {
        "title": "Opening Opposition"
    },
    "cg": {
        "title": "Closing Government"
    },
    "co": {
        "title": "Closing Opposition"
    },
    "c": {
        "title": "Chair"
    },
    "p": {
        "title": "Panel"
    }
};

export const debateRanks = {
    first: {rank: "1", selectionTitle: "1st", displayTitle: "1st"},
    second: {rank: "2", selectionTitle: "2nd", displayTitle: "2nd"},
    third: {rank: "3", selectionTitle: "3rd", displayTitle: "3rd"},
    fourth: {rank: "4", selectionTitle: "4th", displayTitle: "4th"},
    none: {rank: "-1", selectionTitle: "Not Available", displayTitle: ""}
};